export default function promiseDelay(timeoutMs) {
  return new Promise(resolve => setTimeout(resolve, timeoutMs));
}
